export const NEWUSER = 'NEWUSER';
export const DELETEUSER = 'DELETEUSER';
export const UPDATEUSER = 'UPDATEUSER';
export const USERDATA = 'USERDATA';
export const ONEUSERDATA = 'ONEUSERDATA';
export const SHOW_LOADING = 'SHOW_LOADING'